import type { MediaFileIdArrayResponse } from '@coorum-research/shared-common/api-response'
import type { ConnectMediaFilesToOwnerValues } from '@coorum-research/shared-common/types'
import { mediaFileApiFactory } from '@coorum-research/core/src/utils'
import http from './http'

/**
 * shared-client-user media file api
 * - #createUploadImageUrl
 * - #uploadImage
 * は shared-client-admin media file api と同じだけど。http instance が違う。
 * 共通化するなら、httpを受け取るようにする必要があると思う。
 */
export function mediaFileApi() {
  const { uploadImage } = mediaFileApiFactory(http)

  const uploadSurveyAnswerImage = async (file: File) => {
    return await uploadImage(file, {
      ownerType: 'Answer',
      mediaVariant: 'surveyAnswer',
    })
  }

  /**
   * @param ownerId - answer id
   * @param mediaFileUids - media file uid list
   */
  const connectToAnswer = async (ownerId: string, mediaFileUids: string[]) => {
    const data: ConnectMediaFilesToOwnerValues = {
      ownerType: 'Answer',
      ownerId,
      mediaUids: mediaFileUids,
    }
    const response = await http.post<MediaFileIdArrayResponse>(`/medias/connect-owner`, data)
    return response.data
  }

  return {
    uploadSurveyAnswerImage,
    connectToAnswer,
  }
}
